import { useState, useRef, useEffect } from 'react';

export const useSwipe = ({ onRefresh, breakpoint }) => {
  const [startingPoint, setStartingPoint] = useState(0);
  const [movingPoint, setMovingPoint] = useState(0);
  const ref = useRef();
  const height = movingPoint && startingPoint ? movingPoint - startingPoint : 0;
  const [allowRefresh, setAllowRefresh] = useState(false);

  const callback = (entries) => {
    const { isIntersecting } = entries[0];
    if (isIntersecting) {
      setAllowRefresh(true);
    } else {
      setAllowRefresh(false);
    }
  };
  const target = useRef(null);
  const observer = useRef(null);
  if (observer.current) {
    observer.current.disconnect();
  }
  observer.current = new IntersectionObserver(callback, {
    root: null,
    rootMargin: '0px',
    threshold: 0.25,
  });
  if (target.current) {
    observer.current.observe(target.current);
  }

  const touchStart = (e) => {
    const { scrollTop } = ref.current;
    if (scrollTop < 5) setStartingPoint(e.touches[0].clientY);
  };
  const touchEnd = () => {
    if (height > breakpoint && allowRefresh && onRefresh) onRefresh();
    setStartingPoint(0);
    setMovingPoint(0);
  };
  const touchCancel = () => {
    if (height > breakpoint && onRefresh) onRefresh();
    setStartingPoint(0);
    setMovingPoint(0);
  };
  const touchMove = (e) => {
    setMovingPoint(e.touches[0].clientY);
  };

  return {
    height,
    touchStart,
    touchEnd,
    touchCancel,
    touchMove,
    ref,
    target,
  };
};
